import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default, { createElement } from 'react';
import { A as AddIconSvg, D as DownIconSvg, L as LoadingIconSvg, S as SearchIconSvg } from './SearchIcon-835318c0.js';
export { A, L, S, D as j } from './SearchIcon-835318c0.js';
import ChevronLeftSVG from './chevronLeftSVG.js';
export { default as b } from './chevronLeftSVG.js';
import ChevronRightSVG from './chevronRightSVG.js';
export { default as c } from './chevronRightSVG.js';
import ChevronRightThinSVG from './chevronRightThinSVG.js';
export { default as d } from './chevronRightThinSVG.js';
import ChevronUpThinSVG from './chevronUpThinSVG.js';
export { default as e } from './chevronUpThinSVG.js';
import { I as IconQuestionFilled } from './IconQuestionFilled-146e7ca3.js';
export { I as n } from './IconQuestionFilled-146e7ca3.js';
import { I as IconTickFilledSVG } from './icon-tick-filled-3149e72f.js';
export { I as o } from './icon-tick-filled-3149e72f.js';
import MinusCircleSVG from './minusCircle.js';
export { default as r } from './minusCircle.js';
import PlusCircle from './plusCircle.js';
export { default as P } from './plusCircle.js';
import { P as PhotosSVG } from './Photos-5eb9c552.js';
export { P as X } from './Photos-5eb9c552.js';

const CarFinanceSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M12.588 11.412h8.236v1.176h-8.236v8.236h-1.176v-8.236H3.176v-1.176h8.236V3.176h1.176v8.236zM3.765 3.176a.588.588 0 0 0-.589.589v16.47c0 .325.264.589.589.589h16.47a.588.588 0 0 0 .589-.589V3.765a.588.588 0 0 0-.589-.589H3.765zm0-1.176h16.47C21.21 2 22 2.79 22 3.765v16.47C22 21.21 21.21 22 20.235 22H3.765C2.79 22 2 21.21 2 20.235V3.765C2 2.79 2.79 2 3.765 2zM16.08 9.647V7.885h-1.728V6.714h1.728V4.94h1.25v1.773h1.728v1.171H17.33v1.762h-1.25zM4.94 7.882V6.706h4.706v1.176H4.941zm.77 11.177l-.77-.76 1.589-1.588-1.589-1.589.77-.77 1.578 1.6 1.589-1.6.77.77-1.59 1.589 1.59 1.589-.77.759-1.589-1.589-1.578 1.589zm8.642-2.734v-1.09h4.706v1.09h-4.706zm0 1.97v-1.09h4.706v1.09h-4.706z",
  className: "motorway-svg-fill",
  fillRule: "evenodd"
}));

const CarSideSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M14.01 15.65H9.78a3.87 3.87 0 0 0-.25-1.34h4.74a3.87 3.87 0 0 0-.26 1.34zm8.17-.02a3.87 3.87 0 0 0-.25-1.32.7.7 0 0 0 .7-.69v-.8c0-.94-.72-1.72-1.67-1.82l-3.97-.42-1.31-1.55-1.07-1.09a5.35 5.35 0 0 0-4.18-1.59l-5.99.4a1.03 1.03 0 0 0-.85.56l-2.06 4.13-.06.12a.67.67 0 0 0-.1.34v1.72c0 .31.21.58.5.66-.16.41-.25.86-.26 1.32A2.04 2.04 0 0 1 0 13.62V11.9c0-.37.1-.71.28-1.01l2.08-4.17a2.4 2.4 0 0 1 2-1.3l5.97-.4a6.74 6.74 0 0 1 5.28 2l1.1 1.12.98 1.16 3.42.36A3.2 3.2 0 0 1 24 12.81v.81c0 1.04-.8 1.9-1.82 2.02zM5.7 19c-1.87 0-3.4-1.48-3.4-3.3s1.53-3.31 3.4-3.31c1.88 0 3.4 1.48 3.4 3.3S7.57 19 5.7 19zm0-1.34a2 2 0 0 0 2.03-1.97 2 2 0 0 0-2.03-1.96 2 2 0 0 0-2.02 1.96 2 2 0 0 0 2.02 1.97zM18.1 19c-1.87 0-3.4-1.48-3.4-3.3s1.53-3.31 3.4-3.31c1.88 0 3.4 1.48 3.4 3.3S19.98 19 18.1 19zm0-1.34a2 2 0 0 0 2.03-1.97c0-1.08-.9-1.96-2.02-1.96s-2.03.88-2.03 1.96a2 2 0 0 0 2.03 1.97z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const CloseSvg = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M9.69 11.808L2.381 4.456l2.18-2.193 7.307 7.352L19.439 2l2.18 2.193-7.57 7.615 7.951 8L19.82 22l-7.951-8-7.69 7.737L2 19.544l7.69-7.736z",
  className: "motorway-svg-fill",
  fillRule: "evenodd"
}));

const DashSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill",
  d: "M2 10.5h20v3H2z",
  fillRule: "evenodd"
}));

const DashFilled = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
  id: "icon-dash-filled__a",
  d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11v2h10v-2H7z"
})), /*#__PURE__*/React__default.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("mask", {
  id: "icon-dash-filled__b",
  fill: "#fff"
}, /*#__PURE__*/React__default.createElement("use", {
  xlinkHref: "#icon-dash-filled__a"
})), /*#__PURE__*/React__default.createElement("use", {
  xlinkHref: "#icon-dash-filled__a"
}), /*#__PURE__*/React__default.createElement("g", {
  mask: "url(#icon-dash-filled__b)"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z"
}))));

const DiamondSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M19.409 4H4.59L2 8.644 12 20 22 8.644 19.409 4zm-.682 1.25l1.518 2.721h-2.728l1.21-2.72zm-1.293-.059l-1.108 2.491-2.768-2.49h3.876zm-2.58 2.78H9.146L12 5.402l2.855 2.57zm-4.412-2.78L7.674 7.682l-1.108-2.49h3.876zm-5.169.06l1.21 2.72H3.755l1.518-2.72zM4.058 9.163h2.955l3.015 6.78-5.97-6.78zm4.275 0h7.335L12 17.409 8.333 9.163zm5.638 6.78l3.016-6.78h2.955l-5.97 6.78z",
  className: "motorway-svg-fill",
  fillRule: "evenodd"
}));

const CircleLeftSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill",
  d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2a10 10 0 110-20 10 10 0 010 20zm-.6-10l2.7 2.9A.9.9 0 1113 16l-3.4-3.5a.9.9 0 010-1.2l3.4-3.5A.9.9 0 1114 9L11.4 12z",
  fill: "#1D1D1B"
}));

var ErrorIcon = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Arrow-Left-Copy-15",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("circle", {
  id: "Oval-35",
  fill: "#E72F3D",
  cx: "12",
  cy: "12",
  r: "10"
}), /*#__PURE__*/React__default.createElement("path", {
  id: "X",
  fill: "#FFF",
  d: "M12 7.6a.9.9 0 01.9.9v2.599l2.6.001a.9.9 0 110 1.8h-2.6v2.6a.9.9 0 11-1.8 0v-2.6H8.5a.9.9 0 110-1.8l2.6-.001V8.5a.9.9 0 01.9-.9z",
  transform: "rotate(45 12 12)"
}))));

const FacebookIconSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M13.14 23V12.965h3.243l.486-3.911H13.14V6.557c0-1.132.303-1.904 1.866-1.904H17V1.153C16.655 1.106 15.472 1 14.094 1 11.22 1 9.251 2.823 9.251 6.17v2.884H6v3.91h3.251V23h3.889z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const IconCircleFilled = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("circle", {
  className: "motorway-svg-fill",
  cx: 12,
  cy: 12,
  r: 10,
  fillRule: "evenodd"
}));

const IconCircleClose = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  height: 24,
  viewBox: "0 0 24 24",
  width: 24
}, props), /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill",
  fill: "#fff",
  d: "m12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0 2c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zm0-11.273 1.838-1.838a.9.9 0 1 1 1.273 1.273l-1.838 1.838 1.838 1.838a.9.9 0 1 1 -1.273 1.273l-1.838-1.838-1.838 1.838a.9.9 0 1 1 -1.273-1.273l1.838-1.838-1.837-1.838a.9.9 0 0 1 1.273-1.273z"
}));

const IconCircleCloseFilled = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  height: 24,
  viewBox: "0 0 24 24",
  width: 24
}, props), /*#__PURE__*/React__default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("circle", {
  fill: "#1D1D1B",
  cx: "12",
  cy: "12",
  r: "10",
  className: "motorway-svg-fill"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M15.1 8.9c.4.3.4 1 0 1.3L13.3 12l1.8 1.8a.9.9 0 11-1.3 1.3L12 13.3 10.2 15a.9.9 0 11-1.3-1.3l1.8-1.8L9 10.2a.9.9 0 111.3-1.3l1.8 1.8L13.8 9c.4-.4 1-.4 1.3 0z",
  fill: "#FFF"
})));

const IconCircleFilled$1 = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.008-13.52a1.25 1.25 0 0 0 1.264-1.232c0-.656-.528-1.248-1.264-1.248a1.25 1.25 0 0 0-1.248 1.248c0 .64.528 1.232 1.248 1.232zm-1.056 9.12h2.144V9.995h-2.144V17.6z",
  className: "motorway-svg-fill",
  fillRule: "evenodd"
}));

const InstagramIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M12 1c-2.987 0-3.362.013-4.535.066-1.171.054-1.97.24-2.67.512a5.392 5.392 0 0 0-1.949 1.268 5.392 5.392 0 0 0-1.268 1.949c-.272.7-.458 1.499-.512 2.67C1.013 8.638 1 9.013 1 12s.013 3.362.066 4.535c.054 1.171.24 1.97.512 2.67a5.392 5.392 0 0 0 1.268 1.949 5.392 5.392 0 0 0 1.949 1.269c.7.271 1.499.457 2.67.51C8.638 22.988 9.013 23 12 23s3.362-.013 4.535-.066c1.171-.054 1.97-.24 2.67-.511a5.392 5.392 0 0 0 1.949-1.27 5.392 5.392 0 0 0 1.269-1.948c.271-.7.457-1.499.51-2.67.054-1.173.067-1.548.067-4.535s-.013-3.362-.066-4.535c-.054-1.171-.24-1.97-.511-2.67a5.392 5.392 0 0 0-1.27-1.949 5.392 5.392 0 0 0-1.948-1.268c-.7-.272-1.499-.458-2.67-.512C15.362 1.013 14.987 1 12 1zm0 1.982c2.937 0 3.285.011 4.445.064 1.072.049 1.655.228 2.042.379.514.2.88.438 1.265.823.385.385.624.751.823 1.265.15.387.33.97.379 2.042.053 1.16.064 1.508.064 4.445 0 2.937-.011 3.285-.064 4.445-.049 1.072-.228 1.655-.379 2.042-.2.514-.438.88-.823 1.265a3.408 3.408 0 0 1-1.265.823c-.387.15-.97.33-2.042.379-1.16.053-1.508.064-4.445.064-2.937 0-3.285-.011-4.445-.064-1.072-.049-1.655-.228-2.042-.379-.514-.2-.88-.438-1.265-.823a3.408 3.408 0 0 1-.823-1.265c-.15-.387-.33-.97-.379-2.042-.053-1.16-.064-1.508-.064-4.445 0-2.937.011-3.285.064-4.445.049-1.072.228-1.655.379-2.042.2-.514.438-.88.823-1.265a3.408 3.408 0 0 1 1.265-.823c.387-.15.97-.33 2.042-.379 1.16-.053 1.508-.064 4.445-.064zm7.192 3.146a1.32 1.32 0 1 0-2.64 0 1.32 1.32 0 0 0 2.64 0zM12 6.351a5.649 5.649 0 1 1 0 11.298A5.649 5.649 0 0 1 12 6.35zm0 9.316a3.667 3.667 0 1 0 0-7.334 3.667 3.667 0 0 0 0 7.334z",
  className: "motorway-svg-fill",
  fillRule: "evenodd"
}));

const MagnifyingGlassSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M8.66 13.78a7.4 7.4 0 1 1 1.56 1.56l-.05.06-6.28 6.28a1.1 1.1 0 0 1-1.57-1.57l6.28-6.28.06-.05zm1.77-.2a5.91 5.91 0 1 0 8.36-8.37 5.91 5.91 0 0 0-8.36 8.36z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const MoneyIconSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill",
  d: "M16.4 9.6c1.6 0 3 .4 4.2 1 1.2.8 1.9 1.8 1.9 3v3.9c0 1.1-.7 2.2-2 3-1 .6-2.5 1-4.1 1-1.6 0-3.1-.4-4.2-1-.8-.6-1.4-1.1-1.7-1.8a9.2 9.2 0 0 1-2.4.3c-1.6 0-3-.4-4.2-1-1.2-.9-1.9-2-1.9-3V6.9c0-1.1.7-2.1 2-2.8C5 3.4 6.4 3 8 3s3.1.4 4.2 1c1.3.8 2 1.9 2 3v2.8a9.3 9.3 0 0 1 2-.2zm4.9 4c0-.7-.5-1.4-1.4-1.9a7 7 0 0 0-3.5-.9 7 7 0 0 0-3.6 1c-.9.4-1.3 1.1-1.3 1.8 0 .6.4 1.3 1.3 1.8a7 7 0 0 0 3.6 1 7 7 0 0 0 3.5-1c.9-.5 1.4-1.2 1.4-1.8zm-.7 2.9c-1.1.7-2.6 1-4.2 1s-3.1-.3-4.2-1a5.4 5.4 0 0 1-.6-.4c.2.5.6 1 1.2 1.3a7 7 0 0 0 3.6.9 7 7 0 0 0 3.5-1c.6-.3 1-.7 1.2-1.2l-.5.4zm0 2c-1.1.7-2.6 1-4.2 1s-3.1-.3-4.2-1a5.4 5.4 0 0 1-.6-.4c.2.5.6.9 1.2 1.3a7 7 0 0 0 3.6.9 7 7 0 0 0 3.5-1c.6-.3 1-.8 1.2-1.2l-.5.4zm-10.2-5.8A9.2 9.2 0 0 1 8 13c-1.6 0-3-.4-4.2-1.1a5.4 5.4 0 0 1-.5-.4c.1.5.6 1 1.2 1.3a8 8 0 0 0 5.7.6v-.7zm-5.8 4.2a8 8 0 0 0 5.7.6 136 136 0 0 1 0-.7 9.3 9.3 0 0 1-2.2.3c-1.6 0-3-.4-4.2-1.1a5.4 5.4 0 0 1-.5-.4c.1.5.6.9 1.2 1.3zm0-6.1a7 7 0 0 0 3.5.9 7 7 0 0 0 3.6-.9c.6-.4 1-.8 1.2-1.3l-.6.4c-1 .7-2.6 1.1-4.2 1.1s-3-.4-4.2-1a5.4 5.4 0 0 1-.5-.5c.1.5.6 1 1.2 1.3zm0 4a7.9 7.9 0 0 0 5.7.6v-.6A9.3 9.3 0 0 1 8 15c-1.6 0-3-.4-4.2-1a5.4 5.4 0 0 1-.5-.5c.1.5.6 1 1.2 1.3zM3.2 7c0 .7.5 1.3 1.4 1.9a7 7 0 0 0 3.5.9 7 7 0 0 0 3.6-1c.9-.4 1.3-1 1.3-1.8s-.4-1.3-1.3-1.9a7 7 0 0 0-3.6-.9 7 7 0 0 0-3.5 1c-.9.5-1.4 1.1-1.4 1.8z"
}));

var TickIcon = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React__default.createElement("polyline", {
  id: "Path-35",
  className: "motorway-svg-stroke",
  strokeWidth: "2.20000005",
  points: "6 12.2035888 10.1099312 17 18 8"
}))));

const TruePriceLogoSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "76",
  height: "13",
  viewBox: "0 0 76 13"
}, props), /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill",
  d: "M16.8 11.86V3.05h-3.253V1.167h8.666v1.884H18.96v8.808H16.8zm5.067 0V4.138h1.92v1.14h.026c.16-.37.427-.663.8-.901.374-.24.8-.345 1.28-.345.32 0 .48 0 .507.026v1.884c-.027 0-.24-.027-.64-.027-.613 0-1.067.186-1.413.557-.32.372-.507.929-.507 1.672v3.688h-1.973v.026zM33.92 4.138v7.72h-1.947v-.796h-.026c-.187.266-.454.478-.8.664a2.507 2.507 0 0 1-1.2.291c-.854 0-1.494-.265-1.974-.769-.48-.53-.72-1.167-.72-1.963V4.139h1.974v4.643c0 .477.106.822.346 1.06.24.24.56.372.934.372.426 0 .773-.159 1.04-.45.266-.293.4-.69.4-1.195V4.14h1.973zm1.227 3.926c0-1.22.346-2.202 1.04-2.971.693-.743 1.573-1.14 2.613-1.14 1.067 0 1.947.37 2.587 1.087.64.716.96 1.671.96 2.812v.663h-5.2c.053.557.266 1.008.64 1.3.373.292.8.451 1.306.451.694 0 1.28-.238 1.787-.743l1.147 1.354c-.827.742-1.84 1.114-3.067 1.114-1.067 0-1.973-.345-2.72-1.061-.72-.717-1.093-1.672-1.093-2.866zm2.053-.849h3.227c-.054-.504-.214-.902-.507-1.194a1.514 1.514 0 0 0-1.093-.45c-.4 0-.774.159-1.067.45-.32.319-.507.717-.56 1.194zm8.773 4.643h-2.16V1.167h4.134c1.2 0 2.133.345 2.826 1.009.694.663 1.04 1.512 1.04 2.546 0 1.035-.346 1.884-1.04 2.547-.693.664-1.626.982-2.826.982h-1.974v3.608zm0-5.412h1.787c.56 0 .987-.16 1.333-.478.32-.318.507-.742.507-1.247 0-.504-.16-.928-.507-1.273-.32-.345-.773-.504-1.333-.504h-1.787v3.502zm6.774 5.412V4.14h1.92v1.14h.026c.16-.37.427-.663.8-.901.374-.24.8-.345 1.28-.345.32 0 .48 0 .507.026v1.884c-.027 0-.24-.027-.64-.027-.613 0-1.067.186-1.413.557-.32.372-.507.929-.507 1.672v3.688h-1.973v.026zm7.44 0V4.14h-1.974v7.72h1.974zm3.44-5.518c-.32.424-.507.981-.507 1.671 0 .69.16 1.247.507 1.672.32.424.773.636 1.333.636.747 0 1.28-.371 1.573-1.087l1.654.822c-.32.61-.747 1.114-1.307 1.46-.56.344-1.227.53-2 .53-1.147 0-2.053-.372-2.72-1.14-.693-.744-1.013-1.699-1.013-2.866 0-1.168.346-2.123 1.04-2.892.666-.743 1.573-1.14 2.72-1.14a3.88 3.88 0 0 1 2 .53c.56.345 1.013.849 1.306 1.485l-1.653.796c-.32-.742-.827-1.087-1.573-1.087-.587-.027-1.04.185-1.36.61zm4.906 1.724c0-1.22.347-2.202 1.04-2.971.694-.743 1.574-1.14 2.614-1.14 1.066 0 1.946.37 2.586 1.087.64.716.96 1.671.96 2.812v.663h-5.2c.054.557.267 1.008.64 1.3.374.292.8.451 1.307.451.693 0 1.28-.238 1.787-.743l1.146 1.354c-.826.742-1.84 1.114-3.066 1.114-1.067 0-1.974-.345-2.72-1.061-.72-.717-1.094-1.672-1.094-2.866zm2.054-.849h3.226c-.053-.504-.213-.902-.506-1.194a1.514 1.514 0 0 0-1.094-.45c-.4 0-.773.159-1.066.45-.32.319-.507.717-.56 1.194zM58.053 2.15c0 .637.507 1.14 1.147 1.14s1.147-.503 1.147-1.14c0-.637-.507-1.14-1.147-1.14s-1.147.503-1.147 1.14zM4.693 6.5c0 .637.507 1.14 1.147 1.14s1.147-.503 1.147-1.14c0-.637-.507-1.14-1.147-1.14-.613.026-1.147.53-1.147 1.14zM.16 3.422V5.81l5.68-3.263 5.68 3.263V3.422L5.84.16.16 3.422zm11.36 6.156V7.19l-5.68 3.263L.16 7.19v2.388l5.68 3.263 5.68-3.263z"
}));

const TwentyFourHoursSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M11.28 15.222H6.424V14.15c1.092-.719 1.824-1.26 2.384-1.736.703-.625.97-1.12.97-1.633 0-.607-.428-1.046-1.074-1.046-.77 0-1.226.579-1.14 1.4l-1.273-.046c-.105-1.475.874-2.492 2.489-2.492 1.444 0 2.384.942 2.384 2.109 0 .719-.285 1.363-.96 2.044-.398.401-.959.812-1.747 1.316v.019h2.821v1.138zm.683-1.512V12.47l2.85-3.78h1.672v3.883h.979v1.138h-.979v1.512h-1.32V13.71h-3.202zm3.202-1.138v-2.567h-.02l-1.937 2.548v.019h1.957zm5.544-4.573a9.023 9.023 0 0 1 .791 3.715C21.5 16.834 17.239 21 12 21c-5.238 0-9.5-4.166-9.5-9.286 0-5.12 4.262-9.285 9.5-9.285V1l3.654 2.143L12 5.286V3.857c-4.432 0-8.038 3.525-8.038 7.857 0 4.332 3.606 7.857 8.038 7.857s8.038-3.525 8.038-7.857a7.65 7.65 0 0 0-.668-3.143L20.709 8z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const TwitterIconSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M7.548 20c9.056 0 14.01-6.54 14.01-12.213 0-.186 0-.37-.015-.555A9.413 9.413 0 0 0 24 5.01c-.899.347-1.852.575-2.828.675 1.028-.536 1.797-1.38 2.165-2.374-.967.5-2.024.853-3.127 1.042-1.526-1.415-3.952-1.76-5.916-.844-1.964.916-2.98 2.867-2.475 4.759C7.859 8.095 4.17 6.465 1.67 3.783c-1.307 1.962-.639 4.47 1.525 5.73A5.447 5.447 0 0 1 .96 8.976v.054c0 2.044 1.653 3.804 3.95 4.208a5.62 5.62 0 0 1-2.223.074c.645 1.748 2.494 2.946 4.6 2.98-1.743 1.195-3.897 1.844-6.115 1.842-.392 0-.783-.022-1.172-.062 2.252 1.26 4.872 1.928 7.548 1.925",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const UnlockedPadlockSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M14.092 10.996c.799.097 1.42.79 1.42 1.629v7.734c0 .906-.723 1.641-1.612 1.641H4.612C3.722 22 3 21.265 3 20.36v-7.735c0-.905.723-1.64 1.612-1.64h4.874V7.858C9.486 4.63 12.068 2 15.243 2S21 4.628 21 7.86v2.734c0 1.293-1.032 2.343-2.303 2.343-1.27 0-2.303-1.05-2.303-2.343V7.859c0-.644-.518-1.172-1.15-1.172-.634 0-1.152.528-1.152 1.172v3.137zm-9.48 1.55a.079.079 0 0 0-.077.079v7.734c0 .043.035.079.077.079H13.9a.079.079 0 0 0 .077-.079v-7.734a.079.079 0 0 0-.077-.078H4.612zm10.631-8.984c-2.327 0-4.222 1.929-4.222 4.297v3.125h1.536V7.86c0-1.507 1.205-2.734 2.686-2.734 1.48 0 2.687 1.227 2.687 2.734v2.735c0 .43.344.781.767.781.423 0 .768-.35.768-.781V7.859c0-2.368-1.895-4.297-4.222-4.297z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const BuySVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M8.689 19.609a.727.727 0 0 1 0-1.452.727.727 0 0 1 0 1.452zm9.542 0a.727.727 0 1 1 .726-.726c0 .4-.326.726-.726.726zM7.914 15.51c-.343.08-.465.332-.505.532-.058.277.034.486.077.517l12.871-.009a.57.57 0 1 1 .003 1.143h-.685a1.87 1.87 0 1 1-2.887 0H10.13c.266.323.426.736.426 1.186 0 1.031-.84 1.869-1.868 1.869A1.871 1.871 0 0 1 6.82 18.88c0-.46.167-.88.443-1.206-.53-.098-.932-.58-1.006-1.243-.072-.66.201-1.405.838-1.802l-3.26-9.8a1.001 1.001 0 0 0-.952-.686H1.57A.573.573 0 0 1 1 3.571c0-.314.256-.57.57-.57h1.31c.925 0 1.745.59 2.036 1.468L5.32 5.68h16.75c.039 0 .272.016.35.045.297.108.445.44.337.734L20.194 13.2a.575.575 0 0 1-.443.366L7.914 15.51zm6.16-8.402V9.44h2.727l.33-2.331h-3.057zm0 3.474v2.468l2.27-.373.296-2.095h-2.566zm-4.19-3.474l.342 2.331h2.705V7.11H9.885zm.51 3.474l.439 3 2.098-.345v-2.655h-2.537zm-.687 3.185l-.466-3.185H7.253l1.132 3.403 1.322-.218zm8.087-3.185l-.27 1.9 1.505-.247.629-1.653h-1.864zm.491-3.474l-.33 2.331h2.138l.888-2.331h-2.696zM9.074 9.44l-.342-2.331H6.097l.776 2.331h2.2z",
  className: "motorway-svg-fill",
  fillRule: "evenodd"
}));

const DealershipSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M4 13h16V6.5A1.5 1.5 0 0 0 18.5 5h-13A1.5 1.5 0 0 0 4 6.5V13zm0 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3.5A1.5 1.5 0 0 1 2.5 2h19A1.5 1.5 0 0 1 23 3.5V22a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-8h-3.992l.494 1.354c.361.05.995.497.998 1.344v3.15h-.88v1.005c-.001 1.24-1.652 1.226-1.656 0v-1.005H9.028v1.005c0 1.226-1.65 1.24-1.648 0v-1.005H6.5v-3.15c-.001-.847.633-1.295.99-1.344L7.985 14H4zm11.106 0H8.895l-.465 1.331h7.141L15.106 14zm-6.875 3.947c.42 0 .762-.373.762-.833 0-.462-.341-.837-.762-.833-.421-.004-.763.37-.761.833-.002.46.34.834.761.833zm7.538 0c.417 0 .758-.373.761-.833-.003-.462-.344-.837-.761-.833-.425-.004-.767.37-.769.833.002.46.344.834.769.833zM6.5 10.8h11a.5.5 0 1 1 0 1h-11a.5.5 0 1 1 0-1zm0-2.2h11a.5.5 0 1 1 0 1h-11a.5.5 0 0 1 0-1zm0-2.3h11a.5.5 0 1 1 0 1h-11a.5.5 0 0 1 0-1z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const DetailsSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M21 5.544V22.37c0 .449-.352.815-.783.815H3.783c-.43 0-.783-.366-.783-.815V3c0-.448.352-.815.783-.815h16.434c.43 0 .783.367.783.815v2.544zm-1.565 16.012h-.04v-3.83l.04-10.511v-3.4H4.565v17.74h14.87zm-3.208-11.77h-5.454c-.425 0-.773-.36-.773-.8 0-.44.348-.8.773-.8h5.454c.425 0 .773.36.773.8 0 .44-.348.8-.773.8zm-8.444.003a.791.791 0 0 0 .782-.8c0-.442-.35-.8-.782-.8a.791.791 0 0 0-.783.8c0 .442.35.8.783.8zm8.444 3.7h-5.454c-.425 0-.773-.36-.773-.8 0-.44.348-.8.773-.8h5.454c.425 0 .773.36.773.8 0 .44-.348.8-.773.8zm-8.444.004a.791.791 0 0 0 .782-.8c0-.442-.35-.8-.782-.8a.791.791 0 0 0-.783.8c0 .441.35.8.783.8zm.017 4a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6zm8.427-.004h-5.454c-.425 0-.773-.36-.773-.8 0-.44.348-.8.773-.8h5.454c.425 0 .773.36.773.8 0 .44-.348.8-.773.8zM6.43 4.246V1.754c0-.415.359-.754.797-.754.439 0 .797.34.797.754v2.492c0 .415-.358.754-.797.754-.438 0-.797-.34-.797-.754zm4.773 0V1.754c0-.415.359-.754.797-.754.438 0 .797.34.797.754v2.492c0 .415-.359.754-.797.754-.438 0-.797-.34-.797-.754zm4.797 0V1.754c0-.415.359-.754.797-.754.439 0 .797.34.797.754v2.492c0 .415-.358.754-.797.754C16.36 5 16 4.66 16 4.246z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const PersonalDetailsSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M20.663 22.21a1.69 1.69 0 0 1-1.684 1.685H4.705a1.69 1.69 0 0 1-1.684-1.684V3.789a1.69 1.69 0 0 1 1.684-1.684h4.4A2.818 2.818 0 0 1 11.821.126c1.284 0 2.358.821 2.716 1.98h4.442a1.69 1.69 0 0 1 1.684 1.683v18.422zM11.821 3.959a.988.988 0 1 0-.99-.99c0 .527.443.99.99.99zm4.337 10.59c-1.18-.927-2.38-1.516-2.632-1.643-.02-.02-.042-.042-.042-.084v-.842c.127-.253.21-.526.253-.779.105.084.295.042.505-.695.169-.59.063-.8-.084-.842.463-2.252-.59-2.337-.59-2.337s-.168-.315-.59-.547a2.071 2.071 0 0 0-1.22-.253c-.169 0-.337.042-.484.085-.19.063-.358.168-.527.273-.19.105-.379.274-.547.442a2.26 2.26 0 0 0-.59 1.032c-.105.358-.105.758.043 1.158-.19 0-.421.105-.21.863.168.547.315.716.42.716.042.316.148.673.337.99v.736c0 .042-.021.063-.042.084-.274.127-1.453.737-2.632 1.642-.4.316-.631.8-.631 1.306v.758c0 .168.147.315.316.315h9.263a.324.324 0 0 0 .315-.315v-.758c0-.485-.231-.99-.631-1.306z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const PricingSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M6.8 6.6a1.513 1.513 0 1 1 2.139 2.14A1.513 1.513 0 0 1 6.8 6.6zm14.778 8.167l-6.611 6.61a1.1 1.1 0 0 1-1.556 0l-9.314-9.313c-.18-.176-.29-.41-.31-.661l-.662-5.561a2.724 2.724 0 0 1 .408-1.73l2.14 2.138a2.612 2.612 0 0 0 .35 3.267 2.612 2.612 0 1 0 3.694-3.695 2.612 2.612 0 0 0-3.267-.35L4.311 3.333a2.724 2.724 0 0 1 1.73-.408l5.562.661c.25.021.485.131.661.311l9.314 9.314a1.1 1.1 0 0 1 0 1.556zm.778-2.334a2.2 2.2 0 0 1 0 3.111l-6.612 6.611a2.2 2.2 0 0 1-3.11 0l-9.315-9.313a2.257 2.257 0 0 1-.641-1.303l-.622-5.561c-.127-.94.125-1.89.7-2.645L1.16 1.74a.55.55 0 0 1 .78-.779l1.594 1.594a3.575 3.575 0 0 1 2.645-.7l5.56.623c.494.064.952.29 1.304.641l9.314 9.314zm-5.982.829a.416.416 0 0 0-.039-.02.46.46 0 0 0-.63.17l-.007.01-.114.247a1.04 1.04 0 0 1-.572.476 2.063 2.063 0 0 0-.785.493 1.723 1.723 0 0 0-.327-.493 1.538 1.538 0 0 0-.212-.246l.36-.362a.467.467 0 0 0 0-.657.46.46 0 0 0-.654 0l-.409.41a3.757 3.757 0 0 0-.376-.246 2.769 2.769 0 0 1-.441-.345 1.162 1.162 0 0 1-.163-.23 1.08 1.08 0 0 1-.05-.246.559.559 0 0 1 .05-.247c.032-.1.088-.19.163-.262.343-.346.605-.247.8-.116a.46.46 0 0 0 .638-.147.443.443 0 0 0-.114-.614l-.017-.01c-.637-.445-1.389-.346-1.96.23a1.558 1.558 0 0 0-.36.558 1.33 1.33 0 0 0-.13.624c.007.204.052.404.13.592.09.193.212.37.36.526.186.19.401.351.637.476.049.05.114.082.163.132l-.556.558a.466.466 0 0 0 0 .658.46.46 0 0 0 .654 0l.621-.625a.953.953 0 0 1 .164.197c.154.185.26.405.31.641l.033.329a.466.466 0 0 0 .343.378.46.46 0 0 0 .49-.165l.442-.575a.993.993 0 0 1 .49-.328c.29-.097.552-.26.768-.477.136-.132.247-.288.327-.46l.13-.23a.443.443 0 0 0-.157-.604z",
  strokeWidth: 0.2,
  className: "motorway-svg-stroke",
  fillRule: "evenodd"
}));

const CarSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M19.37 9.49l-1.48-4.05A2.02 2.02 0 0 0 15.87 4H8.12c-1.14 0-1.74.67-2.02 1.44L4.62 9.49c-.59.08-1.62.81-1.62 2.2v5.15h1.44v1.65c0 2.03 2.7 2 2.7 0v-1.65h9.71v1.65c0 2 2.7 2.03 2.71 0v-1.65H21V11.7c0-1.39-1.04-2.12-1.63-2.2zM5.83 13.73c-.69 0-1.25-.61-1.25-1.36 0-.76.56-1.37 1.25-1.36.69-.01 1.25.6 1.25 1.36 0 .75-.56 1.36-1.25 1.36zM12 9.45H6.16l1.11-3.19c.13-.45.34-.77.83-.78h7.8c.48 0 .69.33.83.78l1.11 3.2H12zm6.17 4.28c-.7 0-1.25-.6-1.26-1.36 0-.76.56-1.37 1.26-1.36.68-.01 1.24.6 1.24 1.36 0 .75-.56 1.36-1.24 1.36z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const AssignmentSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24
}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20.7 22.2A1.7 1.7 0 0119 24H4.7A1.7 1.7 0 013 22.2V3.8A1.7 1.7 0 014.7 2h4.4a2.8 2.8 0 012.7-2c1.3 0 2.4.8 2.7 2H19a1.7 1.7 0 011.7 1.7v18.4zM11.8 4a1 1 0 10-1-1c0 .5.5 1 1 1zm4.4 5.6c.5 0 .8-.4.8-.8 0-.5-.3-.8-.8-.8h-5.4c-.5 0-.8.3-.8.8 0 .4.3.8.8.8h5.4zm-8.4 0a.8.8 0 00.8-.8c0-.5-.4-.8-.8-.8a.8.8 0 00-.8.8c0 .4.3.8.8.8zm8.4 3.7c.5 0 .8-.4.8-.8 0-.5-.3-.8-.8-.8h-5.4c-.5 0-.8.3-.8.8 0 .4.3.8.8.8h5.4zm-8.4 0a.8.8 0 00.8-.8c0-.5-.4-.8-.8-.8a.8.8 0 00-.8.8c0 .4.3.8.8.8zm0 4a.8.8 0 100-1.6.8.8 0 000 1.6zm8.4 0c.5 0 .8-.4.8-.8 0-.5-.3-.8-.8-.8h-5.4c-.5 0-.8.3-.8.8 0 .4.3.8.8.8h5.4z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

var iconEnvelope = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M3.46 5.1c-.21 0-.42.04-.6.14l8.71 8.44c.21.2.65.2.86 0l8.72-8.44c-.19-.1-.4-.14-.61-.14H3.46zm-1.3.88c-.1.21-.16.45-.16.7v10.57c0 .25.05.5.15.7l6.43-5.76-6.43-6.21zm19.69 0l-6.43 6.21 6.43 5.77c.1-.22.15-.46.15-.71V6.68c0-.25-.06-.49-.15-.7zM9.32 12.9L2.87 18.7c.18.09.38.14.6.14h17.07c.2 0 .4-.05.6-.14l-6.46-5.78-1.6 1.55c-.62.6-1.54.6-2.15 0l-1.61-1.55z",
  fill: "#1D1D1B",
  fillRule: "nonzero",
  className: "motorway-svg-fill"
})));

var TriangleError = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 25 24"
}, props), /*#__PURE__*/React__default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill",
  fill: "#1D1D1B",
  d: "M13.814 3.508l8.463 15.388a1.499 1.499 0 01-1.314 2.223H4.037a1.5 1.5 0 01-1.314-2.223l8.463-15.388a1.5 1.5 0 012.628 0z"
}), /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill-sub",
  fill: "#fff",
  d: "M13.126 14.424L13.318 7h-1.632l.192 7.424h1.248zm-.624 3.936c.624 0 1.152-.512 1.152-1.152 0-.64-.528-1.152-1.152-1.152-.624 0-1.152.512-1.152 1.152 0 .64.528 1.152 1.152 1.152z"
}))));

function SvgIconCalendar(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: "#1D1D1B",
    className: "motorway-svg-fill",
    fillRule: "evenodd",
    d: "M7 4v1.5h-.5a1 1 0 00-.993.883L5.5 6.5V9h13V6.5a1 1 0 00-1-1h-1V4H18a2 2 0 012 2v9a5.084 5.084 0 01-.066.812l-.02.116a4.97 4.97 0 01-.93 2.095l-.069.087a5.015 5.015 0 01-.155.186l-.104.113-.008.009-.053.055-.025.026-.001.001-.033.034-.156.15a5.039 5.039 0 01-1.186.81l-.067.032a4.978 4.978 0 01-.154.07l-.053.022a3.99 3.99 0 01-.181.071l-.033.012a4.954 4.954 0 01-.669.191l-.102.02a4.969 4.969 0 01-.61.078l-.117.005-.12.003-.039.001L6 20a2 2 0 01-2-2V6a2 2 0 012-2h1zm11.5 6.5h-13v7a1 1 0 00.883.993l.117.007h7.059c.559-.612.892-1.112 1-1.5.146-.53.059-1.27-.262-2.22a.5.5 0 01.457-.66l.09.006 3.656.546V10.5zm-2.412 5.329c.073.572.048 1.093-.084 1.572-.094.34-.262.691-.506 1.064a3.504 3.504 0 002.805-2.305zM8.75 2.25A.75.75 0 019.5 3v3.5a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zm6 0a.75.75 0 01.75.75v3.5a.75.75 0 11-1.5 0V3a.75.75 0 01.75-.75zM13 4v1.5h-2.5V4H13z"
  }));
}

function IconPayment(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.4 19.4c-.2.6-.9 1-1.5 1H5c-.8 0-1.5-.7-1.5-1.5V8l.7.2H19c.8 0 1.5.7 1.5 1.5V12h-2.6a2.3 2.3 0 000 4.7h2.6v2.7zM4.4 5.2H8L5.5 6.7H4.3a.8.8 0 01-.7-.8c0-.4.3-.7.7-.7zm8.8-1.3l.8 1.4a.8.8 0 00.1.2l.8 1.2H8.5l4.7-2.8zm4 .5l1.3 2.3h-1.8l-.9-1.5 1.3-.8zm3.2 9.5v1.3h-2.6a.8.8 0 010-1.6h2.6v.3zm1.6 2v-6c0-1.1-.5-2-1.3-2.6L18 2.9a.8.8 0 00-1-.2l-2 1.2-.9-1.5a.8.8 0 00-1-.3l-2.5 1.5H4.3c-1 0-2 .8-2.2 1.8l-.1.3V19c0 1.6 1.4 3 3.1 3H19c1.3 0 2.7-.9 3.1-2.1V16z",
    fill: "#1D1D1B",
    className: "motorway-svg-fill",
    fillRule: "evenodd"
  }));
}

var iconPhone = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M15.59 16.54c1.24-1.26 2.07-2.39 4.98-.14 2.9 2.25.69 3.8-.56 5.07-1.38 1.4-6.78.14-12.04-5.2C2.44 10.9 1.06 5.42 2.57 4.01 3.83 2.75 5.36.5 7.57 3.46c2.35 2.81 1.1 3.65-.14 4.92-.83.85.97 3.24 3.05 5.2 1.93 1.98 4.29 3.95 5.12 2.96z",
  fill: "#1D1D1B",
  fillRule: "evenodd",
  className: "motorway-svg-fill"
})));

const LiveSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24
}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M2.697 1.01a.667.667 0 01.882-.002l.06.059.051.066a.667.667 0 01-.109.875A6.647 6.647 0 001.333 7a6.65 6.65 0 002.07 4.83.667.667 0 01-.919.965A7.977 7.977 0 010 7a7.98 7.98 0 012.697-5.99zm10.606 0A7.98 7.98 0 0116 7a7.977 7.977 0 01-2.484 5.795.667.667 0 01-.92-.966A6.644 6.644 0 0014.666 7c0-1.92-.816-3.725-2.247-4.992a.667.667 0 01-.109-.875l.052-.066.059-.06a.667.667 0 01.882.003zM4.009 3.373a.667.667 0 11.977.907A3.983 3.983 0 003.92 7a3.99 3.99 0 001.355 3.001.667.667 0 01-.882 1A5.321 5.321 0 012.586 7c0-1.354.507-2.64 1.423-3.627zm7.982 0A5.316 5.316 0 0113.414 7c0 1.54-.657 2.988-1.806 4.001a.667.667 0 01-.882-1A3.988 3.988 0 0012.08 7c0-1.016-.38-1.98-1.067-2.72a.667.667 0 01.977-.907zM8 5a2 2 0 110 4 2 2 0 010-4z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

const WhatsappLogo = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  height: 24,
  viewBox: "0 0 103 24",
  width: 103
}, props), /*#__PURE__*/React__default.createElement("path", {
  fill: "#455A64",
  d: "M11.99 0A11.86 11.86 0 001.72 17.77L.04 23.92l6.28-1.65a11.85 11.85 0 005.66 1.44 11.85 11.85 0 000-23.71zm0 21.7a9.85 9.85 0 01-5.02-1.37l-.36-.2-3.73.97 1-3.64-.24-.37A9.85 9.85 0 1112 21.71zm5.4-7.37a46.7 46.7 0 00-2.03-.96c-.27-.1-.46-.15-.66.15s-.77.96-.94 1.16c-.17.2-.35.22-.64.07-.3-.14-1.25-.46-2.38-1.47a8.9 8.9 0 01-1.65-2.05c-.17-.3-.02-.45.13-.6.15-.14.3-.34.44-.52.13-.15.22-.31.3-.5a.55.55 0 00-.02-.5c-.08-.16-.66-1.62-.91-2.21-.26-.6-.48-.5-.67-.51l-.57-.01a1.09 1.09 0 00-.8.37c-.26.3-1.03 1.01-1.03 2.47 0 1.45 1.06 2.86 1.21 3.06.15.2 2.09 3.19 5.06 4.47a17.16 17.16 0 001.69.63 4.06 4.06 0 001.86.12c.57-.09 1.75-.72 2-1.41s.25-1.29.17-1.4c-.07-.13-.26-.21-.56-.36zm20.96-.18h-.03l-1.96-7.93h-2.37l-2 7.83h-.03l-1.82-7.83h-2.53l3.04 11.5h2.57l1.92-7.82h.03l1.95 7.83h2.5l3.1-11.5h-2.48l-1.89 7.92zm12.09-4.04a2.24 2.24 0 00-.93-.69 3.9 3.9 0 00-1.5-.25 3 3 0 00-1.33.33 2.64 2.64 0 00-1.11 1.06h-.05V6.22h-2.28v11.5h2.28v-4.36c0-.85.14-1.46.41-1.83.28-.37.73-.55 1.36-.55.54 0 .93.17 1.14.5.22.34.32.85.33 1.54v4.7h2.28V12.6a6.72 6.72 0 00-.13-1.41 2.7 2.7 0 00-.47-1.08zm9.42 5.76v-4.33a2 2 0 00-.34-1.22 2.31 2.31 0 00-.87-.72 3.94 3.94 0 00-1.18-.34 9.38 9.38 0 00-1.27-.1 6.9 6.9 0 00-1.37.15 3.92 3.92 0 00-1.24.45c-.36.22-.67.5-.9.86-.25.4-.39.86-.4 1.34h2.28c.05-.45.2-.78.45-.97.26-.19.61-.29 1.06-.29.2 0 .39.02.58.04.16.03.32.08.46.16a.88.88 0 01.33.34c.08.19.13.39.12.59a.62.62 0 01-.21.54c-.18.14-.4.23-.62.28-.29.07-.58.12-.88.15-.33.03-.67.07-1.02.13a9.75 9.75 0 00-1.02.21 2.87 2.87 0 00-.9.41c-.27.2-.5.45-.65.74a2.44 2.44 0 00-.24 1.17c-.01.38.06.76.21 1.1.14.3.34.57.6.78.27.2.58.36.9.45a4.1 4.1 0 001.12.15c.51 0 1.02-.08 1.51-.23.5-.15.94-.42 1.3-.79a3.52 3.52 0 00.15.8h2.32a1.94 1.94 0 01-.22-.77 8.66 8.66 0 01-.07-1.08zm-2.29-1.37a4.4 4.4 0 01-.04.52c-.03.22-.1.44-.22.64a1.5 1.5 0 01-.55.54 2 2 0 01-1.05.23c-.17 0-.35-.02-.53-.05a1.3 1.3 0 01-.45-.17.87.87 0 01-.3-.33 1.08 1.08 0 01-.12-.52 1.12 1.12 0 01.12-.53c.07-.13.17-.25.3-.35a1.52 1.52 0 01.43-.21 4.43 4.43 0 011.05-.21 8.12 8.12 0 001-.2 1.01 1.01 0 00.36-.2v.84zm6.55-7.6h-2.28v2.5h-1.4v1.53h1.4v4.9c-.02.36.05.7.2 1.02.14.25.33.46.58.6.26.15.54.24.84.29.33.05.67.07 1 .07.23 0 .46 0 .7-.02.21 0 .43-.03.64-.06v-1.77a2.87 2.87 0 01-.34.05l-.37.01c-.38 0-.64-.06-.77-.19s-.2-.39-.2-.77v-4.13h1.69V9.4h-1.7V6.9zm9.45 7.18a2.08 2.08 0 00-.6-.66 3.22 3.22 0 00-.85-.43 9.97 9.97 0 00-.97-.28l-.95-.2a7.42 7.42 0 01-.83-.22 1.72 1.72 0 01-.57-.32.62.62 0 01-.23-.5.61.61 0 01.13-.4.85.85 0 01.31-.24c.13-.06.27-.1.41-.1l.42-.03c.37 0 .74.07 1.07.24.3.15.46.45.5.89h2.17a2.73 2.73 0 00-.4-1.28 2.6 2.6 0 00-.83-.81 3.47 3.47 0 00-1.13-.44 6.56 6.56 0 00-1.31-.13c-.44 0-.89.04-1.32.12-.4.08-.8.22-1.16.42a2.31 2.31 0 00-.83.81c-.22.4-.33.86-.31 1.32a1.78 1.78 0 00.82 1.56c.26.17.54.3.84.4.32.1.64.2.98.27.64.12 1.28.3 1.9.51.46.18.69.43.69.78a.84.84 0 01-.15.5 1.09 1.09 0 01-.36.33c-.15.08-.3.14-.48.17a2.4 2.4 0 01-.5.06 2.6 2.6 0 01-.65-.08 1.66 1.66 0 01-.56-.25 1.25 1.25 0 01-.55-1.07H66.1c0 .49.13.97.38 1.4.22.35.52.66.88.88.38.24.8.4 1.23.48.47.1.94.15 1.42.15a7.2 7.2 0 001.4-.14 3.5 3.5 0 001.2-.48c.36-.22.66-.53.87-.89.23-.42.35-.9.33-1.38a1.94 1.94 0 00-.22-.96h-.01zm4.54-7.86l-4.35 11.5h2.55l.9-2.56h4.3l.87 2.57h2.63l-4.3-11.5h-2.6zm-.24 7.06l1.5-4.22h.03l1.45 4.22h-2.98zm15.05-2.76a3.5 3.5 0 00-1.18-.98 3.6 3.6 0 00-1.69-.37c-.49 0-.97.1-1.42.3a2.52 2.52 0 00-1.06 1h-.03V9.4h-2.18v11.24h2.3V16.7h.02c.27.4.64.71 1.07.92.45.21.94.32 1.43.32a3.45 3.45 0 001.6-.36 3.39 3.39 0 001.14-.95 4.09 4.09 0 00.69-1.37 5.8 5.8 0 00.22-1.61 6.4 6.4 0 00-.22-1.7 4.17 4.17 0 00-.7-1.42zm-1.47 4.05a2.42 2.42 0 01-.33.84 1.86 1.86 0 01-3.1 0 2.52 2.52 0 01-.34-.84 4.65 4.65 0 01-.1-.98c-.01-.34.02-.67.09-1 .05-.3.17-.6.33-.86.15-.24.36-.45.6-.6.3-.17.62-.25.95-.24a1.74 1.74 0 011.55.85c.16.27.28.56.34.87a4.57 4.57 0 01.01 1.96zm11.28-2.62a4.17 4.17 0 00-.7-1.43 3.48 3.48 0 00-1.17-.98 3.6 3.6 0 00-1.69-.37 3.25 3.25 0 00-1.42.3 2.52 2.52 0 00-1.06 1h-.04V9.4h-2.17v11.24h2.28V16.7h.04c.26.4.63.71 1.07.92.44.21.93.32 1.42.32a3.46 3.46 0 001.6-.36 3.4 3.4 0 001.15-.95 4.09 4.09 0 00.68-1.37 5.7 5.7 0 00.23-1.61 6.3 6.3 0 00-.23-1.7zm-2.16 2.62a2.4 2.4 0 01-.33.84 1.94 1.94 0 01-2.5.59 1.79 1.79 0 01-.61-.6 2.55 2.55 0 01-.34-.83 4.65 4.65 0 01-.1-.98c0-.34.03-.67.1-1 .05-.3.16-.6.33-.86a1.75 1.75 0 011.55-.84 1.74 1.74 0 011.55.85c.16.27.28.56.34.87a4.57 4.57 0 010 1.96z"
}));

const LocationSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24
}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12.602 23.332c4.505-4.76 7.18-8.255 8.022-10.48a9.248 9.248 0 10-17.204.254c.883 2.138 3.522 5.545 7.921 10.224a.867.867 0 001.261.002zM11.971 5.82a3.758 3.758 0 100 7.513 3.758 3.758 0 000-7.513z",
  className: "motorway-svg-fill",
  fillRule: "evenodd"
}));

const InfoFilled = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24
}, props), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("circle", {
  id: "prefix__a",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React__default.createElement("path", {
  id: "prefix__c",
  d: "M10 0a10 10 0 110 20 10 10 0 010-20zm1.09 7.56H8.94v8.24h2.15V7.56zM9.99 4.2a1.25 1.25 0 00-1.24 1.25c0 .64.53 1.23 1.25 1.23a1.25 1.25 0 001.26-1.23c0-.66-.53-1.25-1.26-1.25z"
})), /*#__PURE__*/React__default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10",
  fill: "#fff"
}), /*#__PURE__*/React__default.createElement("g", {
  transform: "translate(2 2)"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M10 0a10 10 0 110 20 10 10 0 010-20zm1.09 7.56H8.94v8.24h2.15V7.56zM9.99 4.2a1.25 1.25 0 00-1.24 1.25c0 .64.53 1.23 1.25 1.23a1.25 1.25 0 001.26-1.23c0-.66-.53-1.25-1.26-1.25z",
  fill: "#0397D8"
}))));

function EmailOutlineSVG(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), /*#__PURE__*/createElement("path", {
    className: "motorway-svg-fill",
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M4.093 5.083C2.946 5.083 2 6.016 2 7.15v9.639c0 1.132.946 2.066 2.093 2.066h15.814c1.147 0 2.093-.934 2.093-2.066v-9.64c0-1.132-.946-2.065-2.093-2.065H4.093zm.313 1.377h15.188l-7.383 7.043c-.072.07-.35.07-.422 0L4.406 6.46zm-1.01.954L8.3 12.09l-4.906 4.662V7.414zm17.209 0v9.338l-4.906-4.662 4.906-4.676zM9.304 13.051l1.511 1.442a1.71 1.71 0 002.37 0l1.511-1.442 4.651 4.426H4.653l4.65-4.426z"
  }));
}

function PhoneOutlineSVG(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), /*#__PURE__*/createElement("path", {
    className: "motorway-svg-fill",
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M4.98 1.391c-.729.14-1.303.547-2.064 1.325l-.282.297c-.148.158-.43.459-.52.55-2.15 1.986.204 8.138 5.409 13.166 4.814 4.895 10.741 7.15 12.846 5.298l.743-.722c.894-.872 1.35-1.49 1.498-2.286.2-1.079-.338-2.119-1.644-3.13-2.29-1.775-3.674-1.83-5.093-.55l-.232.22-.518.528c-.315.37-2.047-.772-4.194-2.955-2.12-2.012-3.366-3.968-3.045-4.295l.597-.6.05-.052C9.907 6.74 9.95 5.39 8.23 3.249l-.15-.183c-.997-1.33-2.027-1.881-3.1-1.675zm2.06 2.455l.315.39c1.18 1.501 1.117 2.125.235 3.053l-.632.636c-1.173 1.193.318 3.531 3.06 6.134l.426.428c2.659 2.632 4.544 3.774 5.639 2.475l.469-.475.084-.082c.98-.942 1.658-.942 3.534.51.956.741 1.261 1.332 1.162 1.866-.077.41-.365.826-.959 1.426l-.763.746-.059.06c-1.297 1.318-6.65-.669-11.113-5.207-4.657-4.5-6.744-9.817-5.492-11.235l.197-.204.524-.556c.68-.72 1.125-1.06 1.559-1.143.513-.099 1.087.208 1.813 1.178z"
  }));
}

function PinOutlineSVG(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), /*#__PURE__*/createElement("path", {
    className: "motorway-svg-fill",
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M12 2a8 8 0 017.484 10.832c-.718 1.896-2.971 4.855-6.76 8.878l-.38.4a.5.5 0 01-.639.039l-.067-.06-.352-.374c-3.703-3.954-5.931-6.842-6.684-8.664A8 8 0 0112 2zm0 1.4A6.6 6.6 0 005.4 10c0 .876.17 1.727.496 2.517.626 1.516 2.557 4.063 5.754 7.533l.353.381.014-.015c3.369-3.606 5.413-6.284 6.096-7.924l.062-.156A6.6 6.6 0 0012 3.4zm0 3.35a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm0 1.4a1.85 1.85 0 100 3.7 1.85 1.85 0 000-3.7z"
  }));
}

const StarIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill",
  d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
}));

const StarOutlineSVG = props => /*#__PURE__*/createElement("svg", _extends({
  width: 24,
  height: 24
}, props), /*#__PURE__*/createElement("path", {
  className: "motorway-svg-stroke",
  fill: "none",
  stroke: "#1D1D1B",
  strokeWidth: 1.2,
  d: "M12 2.7L9.5 9.2h-7L7.8 14 6 20.6l5.4-3.7.6-.3.6.3 5.4 3.7-1.7-6.7 5.1-4.7h-7L12 2.7z"
}));

// @create-index

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AddIcon: AddIconSvg,
  CarFinanceSVG: CarFinanceSVG,
  CarSideSVG: CarSideSVG,
  ChevronLeftSVG: ChevronLeftSVG,
  ChevronRightSVG: ChevronRightSVG,
  ChevronRightThinSVG: ChevronRightThinSVG,
  ChevronUpThinSVG: ChevronUpThinSVG,
  CloseSvg: CloseSvg,
  Dash: DashSVG,
  DashFilled: DashFilled,
  DiamondSVG: DiamondSVG,
  CircleLeftSVG: CircleLeftSVG,
  DownIcon: DownIconSvg,
  ErrorIcon: ErrorIcon,
  FacebookIconSVG: FacebookIconSVG,
  IconCircleFilled: IconCircleFilled,
  IconCircleClose: IconCircleClose,
  IconCircleCloseFilled: IconCircleCloseFilled,
  IconInfoFilled: IconCircleFilled$1,
  IconQuestionFilled: IconQuestionFilled,
  IconTickFilled: IconTickFilledSVG,
  InstagramIconSVG: InstagramIcon,
  LoadingIcon: LoadingIconSvg,
  MagnifyingGlassSVG: MagnifyingGlassSVG,
  MoneyIconSVG: MoneyIconSVG,
  MinusCircle: MinusCircleSVG,
  PlusCircle: PlusCircle,
  SearchIcon: SearchIconSvg,
  TickIcon: TickIcon,
  TruePriceLogo: TruePriceLogoSVG,
  TwentyFourHoursSVG: TwentyFourHoursSVG,
  TwitterIconSVG: TwitterIconSVG,
  UnlockedPadlockSVG: UnlockedPadlockSVG,
  BuySVG: BuySVG,
  DealershipSVG: DealershipSVG,
  DetailsSVG: DetailsSVG,
  PersonalDetailsSVG: PersonalDetailsSVG,
  PricingSVG: PricingSVG,
  CarSVG: CarSVG,
  AssignmentSVG: AssignmentSVG,
  Envelope: iconEnvelope,
  TriangleError: TriangleError,
  Calendar: SvgIconCalendar,
  Payment: IconPayment,
  Phone: iconPhone,
  LiveSVG: LiveSVG,
  WhatsappLogo: WhatsappLogo,
  LocationSVG: LocationSVG,
  InfoFilledSVG: InfoFilled,
  PhotosSVG: PhotosSVG,
  EmailOutlineSVG: EmailOutlineSVG,
  PhoneOutlineSVG: PhoneOutlineSVG,
  PinOutlineSVG: PinOutlineSVG,
  StarIcon: StarIcon,
  StarOutlineSVG: StarOutlineSVG
});

export { StarIcon as $, BuySVG as B, CarFinanceSVG as C, DashSVG as D, ErrorIcon as E, FacebookIconSVG as F, CarSVG as G, AssignmentSVG as H, IconCircleFilled as I, iconEnvelope as J, SvgIconCalendar as K, MagnifyingGlassSVG as M, IconPayment as N, iconPhone as O, LiveSVG as Q, LocationSVG as R, TriangleError as T, UnlockedPadlockSVG as U, InfoFilled as V, WhatsappLogo as W, EmailOutlineSVG as Y, PhoneOutlineSVG as Z, PinOutlineSVG as _, CarSideSVG as a, StarOutlineSVG as a0, index as a1, CloseSvg as f, DashFilled as g, DiamondSVG as h, CircleLeftSVG as i, IconCircleClose as k, IconCircleCloseFilled as l, IconCircleFilled$1 as m, InstagramIcon as p, MoneyIconSVG as q, TickIcon as s, TruePriceLogoSVG as t, TwentyFourHoursSVG as u, TwitterIconSVG as v, DealershipSVG as w, DetailsSVG as x, PersonalDetailsSVG as y, PricingSVG as z };
